import * as React from 'react'
import { Table, Dialog, NumberPicker } from '@alifd/next'
import { useAppSelector, useAppDispatch } from '../../../redux/hooks'
import doLog from '../../../common/log'
import { setInfoNumber } from '../../../redux/reduces/skuSlice'
const {useState} = React;

export default function OrderTable(props: any) {
  const {i18n, type, sku, price: {
    batchNum = 1,
    currencyRule
  }} = props;
  const {currencyPattern, rate, maximumFractionDigits} = currencyRule;
  const {skuAttrs} = sku;
  if (!skuAttrs) return null;
  const [visible, setVisible] = useState(false)
  const dispatch = useAppDispatch()
  const skuInfo = useAppSelector(state => state.sku[type]);
  const {map, price} = skuInfo;

  return <>
    <a className="order-table" href="#" onClick={e => {
      e.preventDefault();
      setVisible(true);
      doLog( '/sc.details.commonLogs','type=open-order-table' );
    }}>{i18n['202107_detail_pc_ShippingFloor_checklist']}</a>
    <Dialog
                    title={i18n["undue_market_action.selectedListTitle"]}
                    footerActions={[]}
                    visible={visible}
                    style={{
                      width: 800
                    }}
                    onClose={() => setVisible(false)}>
                      <Table dataSource={Object.keys(map).filter((i:any) => map[i]?.number > 0)}>
                        {skuAttrs.map((i:any, j:number) => <Table.Column title={i.name} cell={(value: any, index: any, record: string) => {
                          try {
                            const keyArrs = record.split(';')[j];
                            const _map = skuAttrs[j].values.filter((i: { id: string; }) => i.id + '' === keyArrs.split(':')[1]);
                            return _map[0].name;
                          } catch (error) {
                            return ''
                          }
                        }}/>)}
                        <Table.Column title="Unit Price	" cell={(value: any, index: any, record: string) => {
                          return currencyPattern.replace('{0}',((map[record].price || price)*rate).toFixed(2))
                        }}/>
                        <Table.Column title="Quantity	" cell={(value: any, index: any, record: string) => {
                          return <NumberPicker min={0} max={map[record].inventoryCount} step={batchNum} value={map[record].number} onChange={n => {
                            // 更新数量
                            dispatch(setInfoNumber({
                              type,
                              keyword: record,
                              number: n
                            }))
                          }}/>
                        }}/>
                    </Table>
      </Dialog>
  </>
}
